import React from 'react';
import {Button} from '@material-ui/core';
import type {ButtonProps} from '@material-ui/core';

/**
 *  Contained Primary Variant
 * @param props Mui Button Props
 * @constructor
 */
export const EfeButtonPrimary = (props: ButtonProps) => (
    <Button color='primary' variant='contained' {...props} />
);

/**
 *  Contained Secondary Variant
 * @param props Mui Button Props
 * @constructor
 */
export const EfeButtonSecondary = (props: ButtonProps) => (
    <Button color='secondary' variant='contained' {...props} />
);

/**
 *  Contained default Variant
 * @param props Mui Button Props
 * @constructor
 */
export default function EfeBaseButton(props: ButtonProps) {
    return <Button color={'default'} variant={'contained'} {...props} />;
}
